import { ApiDepositEventGet } from '@/api/event/type'
import { Button, Checkbox } from '@/plugins/ant-design-vue/tsx-support'
import { Component } from '@/vue-property-decorator'
import { GlobalManager } from '@/context'
import { RouteName } from '@/router/config'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import BusinessUtils from '@/utils/business-utils'
import EventItemListedRewards from '@/views/event/item/component/listed-rewards'
import ModalBase from '@/mixins/business/modal/modal-base'
import style from './style.module.scss'

@Component<RechargePopup>({
  name: 'RechargePopup'
})
export default class RechargePopup extends ModalBase {
  get popRechargeEvent() {
    const { $state } = useMainStore()
    return $state.popRechargeEvent
  }
  render() {
    const { t } = useI18n()
    const {
      isWeb,
      updateCheckRechargePopup,
      updateCheckRechargeNeverPopup,
      $state
    } = useMainStore()
    return this.renderModal({
      modalConfig: {
        class: [style.main],
        props: {
          closable: true,
          width: BusinessUtils.px2rem(isWeb ? 800 : 690),
          title: this.popRechargeEvent?.[0]?.name
        }
      },
      renderContent: () => {
        return (
          <div class={style.content}>
            <div class={style.rechargeEventlist}>
              {this.popRechargeEvent?.length && (
                <my-scroll direction="y">
                  <EventItemListedRewards
                    styleType={1}
                    event={
                      (this.popRechargeEvent?.[0] ||
                        []) as unknown as ApiDepositEventGet
                    }
                    forwardCallback={() => {
                      GlobalManager.Modal.close('rechargePopup')
                    }}
                  />
                </my-scroll>
              )}
            </div>
            <div class={style.footer}>
              <div class={style.checkBoxGroup}>
                <div
                  class={style.checkBox}
                  onClick={() => {
                    updateCheckRechargePopup(!$state.checkRechargePopup)
                  }}
                >
                  <Checkbox.Tsx checked={$state.checkRechargePopup} />
                  <span> {t('lobby.modal.task.thisTimeNotShow')}</span>
                </div>
              </div>

              <div class={style.checkBoxGroup}>
                <div
                  class={style.checkBox}
                  onClick={() => {
                    updateCheckRechargeNeverPopup(
                      !$state.checkRechargeNeverPopup
                    )
                  }}
                >
                  <Checkbox.Tsx checked={$state.checkRechargeNeverPopup} />
                  <span>{t('lobby.modal.task.neverPop')}</span>
                </div>
              </div>

              <Button.Tsx
                class={style.btn}
                onClick={() => {
                  this.baseClose()
                  this.$router.push({
                    name: RouteName.EVENT
                  })
                }}
              >
                {t('lobby.tabbar.discount')}
              </Button.Tsx>
            </div>
          </div>
        )
      }
    })
  }
}
